import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { mapState } from '@deerplusofficial/pos-helper';
import CartPreOrderListItem from './CartPreOrderListItem';

const Container = styled.div`
  flex-grow: 1;
  overflow: auto;
`;

class CartPreOrderList extends React.PureComponent {
  static propTypes = {
    preOrder: PropTypes.shape({
      list: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          meta: PropTypes.string,
          name: PropTypes.string,
          time: PropTypes.string,
          description: PropTypes.string,
        })
      ),
    }),
  };

  static defaultProps = {
    preOrder: {},
  };

  render() {
    const {
      preOrder: { list },
    } = this.props;

    return (
      <Container>
        {_.map(list, ({ id }) => (
          <CartPreOrderListItem id={id} key={id} />
        ))}
      </Container>
    );
  }
}

export default connect(mapState(['preOrder']))(CartPreOrderList);



// WEBPACK FOOTER //
// ./src/components/Cart/CartPreOrderList.js